import { render, staticRenderFns } from "./ModalSLA.vue?vue&type=template&id=2980147d&"
import script from "./ModalSLA.vue?vue&type=script&lang=js&"
export * from "./ModalSLA.vue?vue&type=script&lang=js&"
import style0 from "./ModalSLA.vue?vue&type=style&index=0&id=2980147d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports